export default "/assets/images/filter-recommandation-RP.dcea42e3923dbee4.jpg";